import { Component, HostListener, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { GridApi, GridOptions, RowGroupingDisplayType } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { CheckboxFieldComponent } from '../core/ag-grid/checkbox-field/checkbox-field.component';
import { DateFieldComponent } from '../core/ag-grid/date-field/date-field.component';
import { DropdownFieldFilterComponent } from '../core/ag-grid/dropdown-field-filter/dropdown-field-filter.component';
import { DropdownFieldComponent } from '../core/ag-grid/dropdown-field/dropdown-field.component';
import { TextareaFieldComponent } from '../core/ag-grid/textarea-field/textarea-field.component';
import { NumberFieldComponent } from '../core/ag-grid/number-field/number-field.component';
import { formatDate } from '@angular/common';
import { LookupService } from '../services/lookup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { ErrorMessageService } from '../services/error-message.service';
import { AgGridSortingService } from '../services/ag-grid-sorting.service';
import { ManagementService } from '../services/management.service';
import { BusinessEntityService } from '../services/business-entity.service';
import { Router } from '@angular/router';
import { AssumedRoleStoreService } from '../services/assumed-role-store.service';
import { SupplierDetailsEditComponent } from '../core/ag-grid/supplier-details-edit/supplier-details-edit.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  domLayout='normal';
  gridApi: GridApi;
  gridColumnApi: any;
  groupDisplayType: RowGroupingDisplayType = "groupRows";
  gridOptions: GridOptions = {
    onGridReady: (params) => this.onGridReady(params),
    onColumnResized: () => this.autoSizeAllColumns(),
    onColumnMoved: () => this.autoSizeAllColumns()
  };
  columnDefMainSupplierDetails = []
  mainTitle = ""
  downloadFileFormat = 'xlsx'; //setting default value as xlsx
  excelStyles: any[];
  rowdataForMainSupplierDetails = [];
  employeeId: number;
  showNoSupplierErrMsg = false;
  showErrorMsg = false;
  pageErrorMsg = '';
  tooltipShowDelay = 100;
  unionTypeValues = [];
  unionStatusValues = [];
  evaluationValues = [];
  legitStatusValues = [];
  filterDataValue: any;
  showUnionTypeErrMsg = false
  showEvaluationErrMsg = false
  showMonthlyConfErrMsg = false
  showContingencyPlanErrMsg = false
  showOverallStatusCommentErrMsg = false
  unionTypeErrorMsg = ''
  evaluationErrorMsg = ''
  monthlyConfErrorMsg = ''
  contingencyPlanErrorMsg = ''
  overallStatusCommentErrorMsg = ''
  successMssg = '';
  showSuccessMsg = false;
  noneSelected = 'None-Selected'
  
  defaultColDef={ 
    suppressNavigable: true,
    suppressMovable: false,
    cellClass: 'no-border',
    enableRowGroup: true,
    unSortIcon: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    wrapText: true,
    suppressHeaderMenuButton: true,
    minWidth: 140,
    suppressFloatingFilterButton: true,
    autoHeight: true,
    sortable: true
  };

  icons = {
    menu: ' ',
    filter: ' '
  }

  loginUserName: string;
  loginUserRole: string;
  displayUnauthorized: boolean;
  cancelAssumedUser: boolean;
  displayScreen: boolean;
  dateFilterParams: any;
  limit = 1000;
  reportPeriod: any;
  supplierUnionContLink: any;
  disableExportMain = true;
  checkValidity: any;
  linkClickErrorMsg: string;
  showNoLinkErrorMsg = false;
  gridContext = {
    currentlyEditingRow: null,
    _tempEditData: {},
    get tempEditData() {
      return this._tempEditData;
    },
    set tempEditData(data) {
      this._tempEditData = data;
    },
    isContingencyValid(nodeId: string) {
      const data = this.tempEditData?.[nodeId];
      if (!data) { return true; } // skip validation if no data
      const hasContingencyPlan = data.contingencyplan === true;
      const hasContingencyPlanSummary = typeof data.contigencyplansummary === 'string' && data.contigencyplansummary.trim().length > 0;
      return hasContingencyPlan || hasContingencyPlanSummary;
    }
  };

  constructor(private readonly lookup: LookupService, private readonly ngxSpinner: NgxSpinnerService, private readonly errorService: ErrorMessageService,
    private readonly sortService: AgGridSortingService, private readonly management: ManagementService, private readonly bservice: BusinessEntityService,
    private readonly router: Router, private readonly assumeRole: AssumedRoleStoreService) {
      this.dateFilterParams = {
        comparator: function (filterLocalDateAtMidnight, cellValue) {
          if (!cellValue) { return -1 };
          const cellDate = new Date(cellValue);
          const cellUTCDate = Date.UTC(cellDate.getUTCFullYear(), cellDate.getUTCMonth(), cellDate.getUTCDate());
          const filterUTCDate = Date.UTC(
            filterLocalDateAtMidnight.getFullYear(),
            filterLocalDateAtMidnight.getMonth(),
            filterLocalDateAtMidnight.getDate()
          );
          if (cellUTCDate === filterUTCDate) { return 0 };
          return cellUTCDate < filterUTCDate ? -1 : 1;
        },
        browserDatePicker: true,
      };
      this.excelStyles = [
      {
        id: 'header',
        interior: {
          color: "#D3D3D3",
          pattern: "Solid"
        },
        alignment: {
          horizontal: "Center",
          vertical: "Center",
          wrapText: true
        },
        font: {
          bold: true
        },
        borders: {
          borderTop: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          },
          borderRight: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          },
          borderBottom: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          },
          borderLeft: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          }
        }
      },
      {
        id: 'cell',
        alignment: {
          horizontal: "Left",
          vertical: "Center",
          wrapText: true
        },
        borders: {
          borderTop: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          },
          borderRight: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          },
          borderBottom: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          },
          borderLeft: {
            color: '#333333',
            lineStyle: 'Continuous',
            weight: 1
          }
        }
      },
      {
        id: 'statusRed',
        interior: {
          color: '#ff7276',
          pattern: 'Solid'
        }
      },
      {
        id: 'statusOrange',
        interior: {
          color: '#FFA500',
          pattern: 'Solid'
        }
      },
      {
        id: 'statusLightGreen',
        interior: {
          color: '#c4ee90',
          pattern: 'Solid'
        }
      },
      {
        id: 'statusYellow',
        interior: {
          color: '#ffe900',
          pattern: 'Solid'
        }
      },
      {
        id: 'statusGreen',
        interior: {
          color: '#00b740',
          pattern: 'Solid'
        }
      },
      {
        id: 'statusLightPink',
        interior: {
          color: '#f1abb9',
          pattern: 'Solid'
        }
      },
      {
        id: 'statusGrey',
        interior: {
          color: '#b9b9b9',
          pattern: 'Solid'
        }
      }
      ]
  }

  async ngOnInit() {
    this.ngxSpinner.show()
    this.checkValidity = this.lookup.localStorageData.subscribe(async data => { 
      if(data?.includes('success')){
        this.displayUnauthorized = false;
        this.displayScreen = true;
        this.employeeId=this.bservice.loggedUserEmployeeId;
        this.loginUserName = this.bservice.loggedUserEmployeenameOriginal;
        const localStorageAssumeUser= JSON.parse(localStorage.getItem('userAssumed'));
        if(localStorageAssumeUser){
          this.assumeRole.assumeRoleByLocalStorage(localStorageAssumeUser)
        }else{
          this.assumeRole.assumeRoleByBService()
        }
        await this.getReportPeriod()
        await this.getUnionFilterData()
        await this.getMainDataDetails(this.employeeId, 1)
        this.setColumnValues()
      } else if(data?.includes('failure')) {
        this.displayUnauthorized = true;
        this.displayScreen = false;
        const localStorageAssumeUser = localStorage.getItem('userAssumedData');
        if (localStorageAssumeUser==='noData') {
          this.cancelAssumedUser = true;
        }
        this.ngxSpinner.hide();
      }
    })
  }

  setColumnValues() {
    this.columnDefMainSupplierDetails = [{
        headerName: 'Action', field: 'action', width: 80, minWidth: 80, filter: false,
        enableRowGroup: false, lockPosition: true, sortable: false,
        cellRenderer: SupplierDetailsEditComponent,
        cellRendererParams: {
          update: this.updateSupplierDetailsMain.bind(this),
          cancel: this.cancelUpdateMain.bind(this),
        }, pinned: 'left', lockPinned: true,
      },
      {
        headerName: 'Supplier Code', field: 'suppliercode', width: 140,
        lockPosition: true, pinned: 'left', lockPinned: true,
      },
      {
        headerName: 'Supplier Name', field: 'suppliername', width: 140,
        lockPosition: true, pinned: 'left', lockPinned: true,
        comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Commodity', field: 'commodity', width: 180,
        comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'NAMCs Supplied', field: 'namc', flex: 1,
        comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'City', field: 'plantcity', flex: 1,
        comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'State', field: 'plantstate', flex: 1,
        comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Union Name (DMH)', field: 'unionname', flex: 1,
        comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Union Type', field: 'uniontype', flex: 1,
        cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: this.unionTypeValues },
      },
      {
        headerName: 'Contract Expiration Date (DMH)', field: 'expirationdate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: (params) => { return this.formatDate(params.value) }
      },
      {
        headerName: 'N-Date', field: 'n_date', flex: 1, sortable: false,
      },
      {
        headerName: 'Legit Planned Date', field: 'legitimizationdate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams, cellRenderer: DateFieldComponent,
      },
      {
        headerName: 'Legit Complete', field: 'legitimizationstatus', flex: 1,
        cellRenderer: DropdownFieldComponent,floatingFilterComponent: DropdownFieldFilterComponent, floatingFilter: true,
        floatingFilterComponentParams: { associatedList: this.legitStatusValues },
      },
      {
        headerName: "MX Gov't. Apprvl. Date (DMH)", field: 'mxapprovaldate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: (params) => { return this.formatDate(params.value) }
      },
      {
        headerName: 'Overall Status Comment', field: 'comment', width: 240, suppressKeyboardEvent: (params) => this.keyboardActionsMain(params),
        cellRenderer: TextareaFieldComponent, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Status', field: 'unionstatus', width: 240,
        cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent, floatingFilter: true,
        floatingFilterComponentParams: { associatedList: this.unionStatusValues }, comparator: this.sortService.stringComparator,
        cellStyle: (params) => {
          if(params.value === this.unionStatusValues[1]) { return { backgroundColor: '#ff7276' }
          } else if(params.value === this.unionStatusValues[2]) { return { backgroundColor: '#FFA500' }
          } else if((params.value === this.unionStatusValues[3]) || (params.value === this.unionStatusValues[7])) {
            return { backgroundColor: '#c4ee90' }  
          } else if(params.value === this.unionStatusValues[4]) { return { backgroundColor: '#ffe900' }
          } else if((params.value === this.unionStatusValues[5]) || (params.value === this.unionStatusValues[6])){
            return { backgroundColor: '#f1abb9' }
          } else if(params.value === this.unionStatusValues[8]) { return { backgroundColor: '#00b740' }
          } else if(params.value === this.unionStatusValues[9]) { return { backgroundColor: '#b9b9b9' }}
          return null;
        },
        cellClass: (params) => { 
          if(params.value === this.unionStatusValues[1]) { return 'statusRed'
          } else if(params.value === this.unionStatusValues[2]) { return 'statusOrange'
          } else if((params.value === this.unionStatusValues[3]) || (params.value === this.unionStatusValues[7])) {
            return 'statusLightGreen'
          } else if(params.value === this.unionStatusValues[4]) { return 'statusYellow'
          } else if((params.value === this.unionStatusValues[5]) ||  (params.value === this.unionStatusValues[6])){
            return 'statusLightPink'
          } else if(params.value === this.unionStatusValues[8]) { return 'statusGreen'
          } else if(params.value === this.unionStatusValues[9]) { return 'statusGrey' }
          return null;
        }
      },
      {
        headerName: 'Inventory Bank (Days)', field: 'inventorybank', flex: 1, cellRenderer: NumberFieldComponent,
        suppressKeyboardEvent: (params) => this.keyboardActionsMain(params)
      },
      {
        headerName: 'Bank Build on Contingency Plan?', field: 'bankbuildoncontingencyplan', flex: 1,
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.bankbuildoncontingencyplan === true ? 'Checked': 'Unchecked'; },
        headerTooltip: 'Bank Build on Contingency Plan?',
      },
      {
        headerName: 'Bank Build Verified by N-1?', field: 'bankbuildverifiedbyn1', flex: 1,
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.bankbuildverifiedbyn1 === true ? 'Checked' : 'Unchecked'; },
        headerTooltip: 'Bank Build Verified by N-1?',
      },
      {
        headerName: 'Expected New Contract Completion Date', field: 'expectedcompletion', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: DateFieldComponent, headerTooltip: 'Expected New Contract Completion Date',
      },
      {
        headerName: 'Contingency Plan Developed/ On Schedule', field: 'contingencyplan', flex: 1,
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.contingencyplan === true ? 'Checked' : 'Unchecked'; },
        headerTooltip: 'Contingency Plan Developed/ On Schedule',
      },
      {
        headerName: 'Contingency Plan Summary', field: 'contigencyplansummary', suppressKeyboardEvent: (params) => this.keyboardActionsMain(params),
        width: 240, cellRenderer: TextareaFieldComponent, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Overall Evaluation', field: 'evaluation', flex: 1,
        cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: this.evaluationValues },
      },
      {
        headerName: 'Primary Sales Contact', field: 'primarysalescontact', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Email', field: 'primarysalescontactemail', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Buyer', field: 'buyer', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Manager', field: 'manager', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Senior Manager', field: 'seniormanager', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Monthly Confirmation', field: 'monthlyconfirmation', flex: 1,
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.monthlyconfirmation === true ? 'Checked' : 'Unchecked'; },
      },
      {
        headerName: 'Signed Contingency Plan (DMH)', field: 'signedcontingencyfile', flex: 1,
        comparator: this.sortService.stringComparator,
        cellRenderer: (params) => {
          if(params?.value !== null && params?.value !== undefined) {
            return `<a class="linkClick">${this.fileNameDownloadMain(params.value)}</a>`;
          } else {
            return '';
          }
        },
        onCellClicked: (params) => { // Handle the click event for the contract file
          if (params.column.getColId() === 'signedcontingencyfile' && params.data.signedcontingencyfile) {// Check if the clicked cell belongs to the 'signedcontingencyfile' column and has a value
            const fileUrl = params.data.signedcontingencyfile; // Assuming params.value holds the direct URL to the PDF
            this.contractContingencyFileDownload(fileUrl)
          }else{
            this.ngxSpinner.hide()
            this.showErrorMessage(this.errorService.downloadFileErrMsg)
          }
        }
      },
      {
        headerName: 'Contract (DMH)', field: 'contractfile', flex: 1, comparator: this.sortService.stringComparator,
        cellRenderer: (params) => {
          if(params?.value !== null && params?.value !== undefined) {
            return `<a class="linkClick">${this.fileNameDownloadMain(params.value)}</a>`;
          } else {
            return '';
          }
        },
        onCellClicked: (params) => { // Handle the click event for the contract file
          if (params.column.getColId() === 'contractfile' && params.data.contractfile) {// Check if the clicked cell belongs to the 'contractfile' column and has a value
            const fileUrl = params.data.contractfile; // Assuming params.value holds the direct URL to the PDF
            this.contractContingencyFileDownload(fileUrl)
          }else{
            this.ngxSpinner.hide()
            this.showErrorMessage(this.errorService.downloadFileErrMsg)
          }
        }
      },
    ];
  }

  contractContingencyFileDownload(fileUrl: any) {
    this.ngxSpinner.show()
    this.lookup.downloadContractOrSignedContingencyFile(fileUrl).subscribe({
    next: data=>{
      if(data['statusCode'] === 200){
        window.open(data.body.url, '_blank'); // Open the PDF in a new tab/window for download or viewing
        this.ngxSpinner.hide()
      }else{
        this.ngxSpinner.hide()
        this.showErrorMessage(this.errorService.downloadFileErrMsg)
      }
    },
    error: _error=>{ 
      this.ngxSpinner.hide()
      this.showErrorMessage(this.errorService.downloadFileErrMsg)
    }});
  }

  keyboardActionsMain(params) {
    const event = params.event;
    const target = event.target as HTMLElement;
    const isTextInput = target.tagName === 'TEXTAREA' || target.tagName === 'INPUT';
    if (isTextInput) {
      const key = event.key.toLowerCase();
      const isCtrlCombo = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(key);
      const isArrowKey = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key);
      if (isCtrlCombo || isArrowKey) {
        return true; // Suppress ag-Grid handling; allow default browser behavior
      }
    }
    return false;
  }

  fileNameDownloadMain(value) {
    if(!value) {
      return '';
    } else {
      return value.split('/').pop();
    }
  }

  async getUnionFilterData() {
    const data = await lastValueFrom(this.lookup.getUnionFilters())
    if(data.statusCode === 200 &&  !data?.body?.errorResponse) {
      this.lookup.setFilterData(data)
      this.unionTypeValues = ['All', ...(data.body?.unionType ?? []).map(value => value.uniontype)];
      this.unionStatusValues = ['All', ...(data.body?.unionStatus ?? []).map(value => value.unionstatus)];
      this.evaluationValues = ['All', ...(data.body?.evaluation ?? []).map(value => value.greekletter)];
      this.legitStatusValues = ['All', ...(data.body?.legit ?? [])];
    } else {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.showErrorMessage(this.errorService.notAbleToGetFilterDetails)
    }
  }

  async getReportPeriod() {
    try {
      const data = await lastValueFrom(this.lookup.getReportPeriod())
      if(data.statusCode === 200 &&  !data?.body?.errorResponse) {
        if(data.body.response && data.body.response.length > 0) {
          this.mainTitle = data?.body?.response[0]?.name
          this.reportPeriod = data?.body?.response[0]?.unionreportperiodid
          this.getReportPeriodInfo(this.reportPeriod)
        } else {
          window.scroll(0,0);
          this.ngxSpinner.hide()
          this.showErrorMessage(this.errorService.notAbleToGetReportPeriodName)
        }
      } else {
        window.scroll(0,0);
        this.ngxSpinner.hide()
        this.showErrorMessage(this.errorService.serverErrMsg)
      }
    } catch {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.showErrorMessage(this.errorService.serverErrMsg)
    }
  }

  getReportPeriodInfo(reportPeriod) {
    this.ngxSpinner.show();
    this.lookup.getreportPeriodInfo(reportPeriod).subscribe({
      next: (data) => {
        if (data?.body[0]) {
          this.supplierUnionContLink = data?.body[0]?.supplierunioncontingencypath;
        }
      },
      error: (err) => {
        if (err) {
          this.ngxSpinner.hide();
          window.scroll(0,0);
          this.showErrorMessage(this.errorService.notAbleToGetReportPeriodInfoDetails)
        }
      }
    }); 
  }

  onLinkClick() {
    if(this.supplierUnionContLink){
      const path = document.getElementById('supplierunioncontingency');
      path.setAttribute("href", this.supplierUnionContLink); 
      path.setAttribute("target", "_blank");
      path.click();
    } else {
      window.scroll(0, 0)
      this.showErrorMsg = true
      this.showNoLinkErrorMsg = true
      this.linkClickErrorMsg = this.errorService.updateSupplierUnionContPath
      setTimeout(()=>{
        this.showErrorMsg = false
        this.showNoLinkErrorMsg = false
      }, 10000)
    }
  }

  async getMainDataDetails(employeeId, page) {
    this.ngxSpinner.show()
    try { 
      const data = await lastValueFrom(this.lookup.getSupplierListDetails(page, this.limit, employeeId))
      if(data['statusCode']===200 && data?.body?.mainPage && data?.body?.mainPage?.length > 0 && !data?.body?.errorResponse) {
        //setting total number of packets
        if(page === 1) {
          this.rowdataForMainSupplierDetails = []
        }
        //If page is greater than 1, then push data to the rowData
        if(page>1) {
          this.ngxSpinner.hide();
          this.rowdataForMainSupplierDetails = [...this.rowdataForMainSupplierDetails, ...data.body.mainPage]
        } else {
          this.rowdataForMainSupplierDetails = data?.body?.mainPage;
        }
        //If mainPage response length equal to 1000, call the api again to fetch date from next page
        if(data?.body?.mainPage?.length === this.limit) {
          page += 1;
          this.getMainDataDetails(employeeId, page)
        }
        this.disableExportMain = false;
      } else {
        window.scroll(0,0);
        this.ngxSpinner.hide()
        this.disableExportMain = true;
        this.rowdataForMainSupplierDetails = []
        this.showErrorMessage(this.errorService.noDetailsAvailable)
      }
    } catch {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.disableExportMain = true;
      this.rowdataForMainSupplierDetails = []
      this.showErrorMessage(this.errorService.serverErrMsg)
    } finally {
      this.ngxSpinner.hide()
    }
  }

  onTabChanged(_event: MatTabChangeEvent) {}

  updateSupplierDetailsMain(params){  //NOSONAR
    this.ngxSpinner.show()
    this.lookup.getFilterData().subscribe(data => {
      this.filterDataValue = data.body
    })
    this.showSuccessMsg = false
    this.showErrorMsg = false
    this.showUnionTypeErrMsg = false
    this.showEvaluationErrMsg = false
    this.showMonthlyConfErrMsg = false
    this.showContingencyPlanErrMsg = false
    this.showOverallStatusCommentErrMsg = false
    const updateDataRequestBody = {
      "unionId": params.rowData?.unionid,
      "empId": this.employeeId,
      "unionTypeId": this.getUnionTypeId(params.rowData?.uniontype),
      "legitDate": params.rowData?.legitimizationdate,
      "legitStatus": params.rowData?.legitimizationstatus,
      "comment": params.rowData?.comment?.trim(),
      "unionStatusId": this.getUnionStatusId(params.rowData?.unionstatus),
      "invBank": params.rowData?.inventorybank,
      "bankContPlan": params.rowData?.bankbuildoncontingencyplan,
      "bankVerified": params.rowData?.bankbuildverifiedbyn1,
      "expectComp": params.rowData?.expectedcompletion,
      "contPlan": params.rowData?.contingencyplan,
      "contSummary": params.rowData?.contigencyplansummary?.trim(),
      "evaluation": this.getEvaluationValue(params.rowData?.evaluation),
      "monthConf": params.rowData?.monthlyconfirmation
    }
    if((updateDataRequestBody.unionTypeId !== '' && updateDataRequestBody.unionTypeId != null && updateDataRequestBody.unionTypeId !== this.noneSelected) 
      && (updateDataRequestBody.evaluation !== '' && updateDataRequestBody.evaluation != null) && (updateDataRequestBody.comment !== '' && updateDataRequestBody.comment != null)
      && updateDataRequestBody.monthConf !== false && (updateDataRequestBody.contPlan !== false || (updateDataRequestBody.contSummary !== '' && updateDataRequestBody.contSummary != null))) {
      this.management.updateMainData(updateDataRequestBody).subscribe((data) => {
        if(data.statusCode === 200 && !data?.body?.errorResponse) {
          this.getMainDataDetails(this.employeeId, 1)
          this.showSuccessMsg = true
          this.successMssg = 'Data Updated Successfully.'
          setTimeout(()=>{
            this.showSuccessMsg = false
          }, 10000)
        } else {
          this.ngxSpinner.hide()
          this.showErrorMessage(this.errorService.dataUpdateFailure)
        }
        window.scroll(0,0);
      })
    } else {
      this.ngxSpinner.hide()
      window.scroll(0,0);
      if(updateDataRequestBody.unionTypeId === this.noneSelected || updateDataRequestBody.unionTypeId === '' || updateDataRequestBody.unionTypeId == null) {
        this.showErrorMsg = true
        this.showUnionTypeErrMsg = true
        this.unionTypeErrorMsg = this.errorService.unionTypeErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showUnionTypeErrMsg = false
        }, 10000)
      }
      if(updateDataRequestBody.evaluation === '' || updateDataRequestBody.evaluation == null) {
        this.showErrorMsg = true
        this.showEvaluationErrMsg = true
        this.evaluationErrorMsg = this.errorService.evaluationErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showEvaluationErrMsg = false
        }, 10000)
      }
      if(updateDataRequestBody.comment === '' || updateDataRequestBody.comment == null) {
        this.showErrorMsg = true
        this.showOverallStatusCommentErrMsg = true
        this.overallStatusCommentErrorMsg = this.errorService.statusCommentErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showOverallStatusCommentErrMsg = false
        }, 10000)
      }
      if(updateDataRequestBody.contPlan === false && ((updateDataRequestBody.contSummary === '') || (updateDataRequestBody.contSummary == null))) {
        this.showErrorMsg = true
        this.showContingencyPlanErrMsg = true
        this.contingencyPlanErrorMsg = this.errorService.contingencyPlanErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showContingencyPlanErrMsg = false
        }, 10000)
      }
      if(updateDataRequestBody.monthConf === false) {
        this.showErrorMsg = true
        this.showMonthlyConfErrMsg = true
        this.monthlyConfErrorMsg = this.errorService.monthlyConfirmationErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showMonthlyConfErrMsg = false
        }, 10000)
      }
    }
  }

  getEvaluationValue(value) {
    if(value !== null && value !== undefined) {
      const selectedEvaluation = this.filterDataValue?.evaluation.find((item) => item.greekletter === value || item.symbol === value)
      if(selectedEvaluation !== undefined) {
        return selectedEvaluation.symbol
      } else {
        return null
      }
    }
    return value
  }

  getUnionTypeId(value) {
    if(value !== null && value !== undefined) {
      if(value === this.noneSelected) {
        return value
      } else {
        const selectedUnionType = this.filterDataValue?.unionType.find((item) => item.uniontypeid === value || item.uniontype === value)
        if(selectedUnionType !== undefined) {
          return selectedUnionType.uniontypeid
        } else {
          return null
        }
      }
    }
    return value
  }

  getUnionStatusId(value) {
    if(value !== null && value !== undefined) {
      const selectedUnionStatus = this.filterDataValue?.unionStatus.find((item) => item.unionstatusid === value || item.unionstatus === value)
      if(selectedUnionStatus !== undefined) {
        return selectedUnionStatus.unionstatusid;
      } else {
        return null;
      }
    }
    return value
  }

  cancelUpdateMain(_params){  //NOSONAR
    this.showErrorMsg = false
  }

  exportType(value) {
    if(value === 'xlsx') {
      this.downloadFileFormat = 'xlsx'
    } else if(value === 'xls') {
      this.downloadFileFormat = 'xls'
    } else {
      this.downloadFileFormat = 'csv'
    }
  }

  async exportGridData() {
    this.ngxSpinner.show()
    const date = new Date();
    const formattedDate = formatDate(date, 'M_d_y_h_mma', 'en-US');
    const ignoreFirstColumn = this.columnDefMainSupplierDetails.map(col => col.field).filter(field => field !== 'action');
    const exportParams = {
      fileName: 'Union Tracker Main-'+`${formattedDate}`+`.${this.downloadFileFormat}`,
      sheetName: this.mainTitle,
      columnKeys: ignoreFirstColumn,
      processCellCallback: (params) => {
        if((params.column.getColId() === 'monthlyconfirmation') || (params.column.getColId() === 'contingencyplan') ||
          (params.column.getColId() === 'bankbuildverifiedbyn1') || (params.column.getColId() === 'bankbuildoncontingencyplan')) {
          if(params.value === 'Checked') {
            params.value = 'Yes'
          } else if(params.value === 'Unchecked'){
            params.value = 'No'
          }
          return params.value
        }
        if((params.column.getColId() === 'expirationdate') || (params.column.getColId() === 'legitimizationdate') || (params.column.getColId() === 'expectedcompletion') || (params.column.getColId() === 'mxapprovaldate')) {
          return this.formatDate(params.value)
        }
        return params.value
      }
    }
    await new Promise((resolve)=> {
      if(this.downloadFileFormat === 'csv') {
        this.gridApi.exportDataAsCsv(exportParams)
      } else if(this.downloadFileFormat === 'xls') {
        this.gridApi.exportDataAsExcel(exportParams)
      } else {
        this.gridApi.exportDataAsExcel(exportParams)
      }
      setTimeout(resolve, this.estimateExportTimeMain());
    })
    this.ngxSpinner.hide();
  }

  formatDate(value: string): string {
    if (!value) {
      return '';
    } else {
      const isoformattedDate = value.replace(' ', 'T');
      const parsedDate = new Date(isoformattedDate);
      if (isNaN(parsedDate.getTime())) {
        return 'Invalid Date';
      } else {
        return new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC',
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
        }).format(parsedDate);
      }
    }
  }

  showErrorMessage(message) {
    this.showErrorMsg = true
    this.showNoSupplierErrMsg = true
    this.pageErrorMsg = message
    setTimeout(()=>{
      this.showErrorMsg = false
      this.showNoSupplierErrMsg = false
    }, 10000)
  }

  async exportManagerReportdata() {
    this.ngxSpinner.show()
    const date = new Date();
    const formattedDate = formatDate(date, 'M_d_y_h_mma', 'en-US');
    const exportParams = {
      columnKeys: [
        'suppliercode', 'suppliername', 'plantcity', 'plantstate', 'unionname', 'uniontype', 'expirationdate', 'n_date', 'legitimizationdate', 'legitimizationstatus',
        'mxapprovaldate', 'comment', 'unionstatus', 'inventorybank', 'bankbuildoncontingencyplan', 'bankbuildverifiedbyn1', 'expectedcompletion', 'contingencyplan',
        'contigencyplansummary', 'evaluation', 'primarysalescontact', 'primarysalescontactemail', 'buyer', 'manager'
      ],
      fileName: 'Union Tracker Manager Report-'+`${formattedDate}`+`.${this.downloadFileFormat}`,
      sheetName: this.mainTitle,
      processCellCallback: (params) => {
        if((params.column.getColId() === 'monthlyconfirmation') || (params.column.getColId() === 'contingencyplan') ||
          (params.column.getColId() === 'bankbuildverifiedbyn1') || (params.column.getColId() === 'bankbuildoncontingencyplan')) {
            if(params.value === 'Checked') {
              params.value = 'Yes'
            } else if(params.value === 'Unchecked'){
              params.value = 'No'
            }
            return params.value
        }
        if((params.column.getColId() === 'expirationdate') || (params.column.getColId() === 'legitimizationdate') || (params.column.getColId() === 'expectedcompletion')) {
          return this.formatDate(params.value)
        }
        return params.value
      },
    }
    await new Promise((resolve)=> {
      if(this.downloadFileFormat === 'csv') {
        this.gridApi.exportDataAsCsv(exportParams)
      } else if(this.downloadFileFormat === 'excel.xls') {
        this.gridApi.exportDataAsExcel(exportParams)
      } else {
        this.gridApi.exportDataAsExcel(exportParams)
      }
      setTimeout(resolve, this.estimateExportTimeMain());
    })
    this.ngxSpinner.hide();
  }

  estimateExportTimeMain(): number {
    return this.gridApi ? this.calculateTimeMain() : 0; 
  }

  calculateTimeMain() {
    const rows = this.gridApi?.getDisplayedRowCount();
    return Math.min(5000, rows * 10);
  }

  tabToNextCell(){ //tab to next cell in ag-grid table
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeAllColumns();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    if (this.gridApi) {
      this.debounce(() => {
        this.autoSizeAllColumns();
      }, 100);
    }
  }

  autoSizeAllColumns() {
    const allColumnIds: string[] = [];
    this.gridColumnApi?.getAllColumns().forEach((column: any) => {
      allColumnIds.push(column.getColId());
    });
    this.gridColumnApi?.autoSizeColumns(allColumnIds);
  }

  debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  cancelNullGuidAssume() {
    this.displayUnauthorized = false;
    this.displayScreen = true;
    localStorage.clear();
    location.reload();
  }
  
  ngOnDestroy() { 
    sessionStorage.removeItem('page');
    this.checkValidity?.unsubscribe();
  }
}